import React, { useState } from "react";
import { useRoute } from "@react-navigation/native";
import { RootRouteProps } from "routers/types/stack";

import { Header } from "components";
import { strings } from "assets/constants";
import WebView from "react-native-webview";
import WebViewProgress from "./WebViewProgress";

export default function Report() {
  const { type, link } = useRoute<RootRouteProps<"report">>().params;
  const headerTitle =
    type === "sale"
      ? strings.factor_reports
      : type === "seller"
      ? strings.sellers_reports
      : type === "product"
      ? strings.product_reports
      : strings.customer_reports;

  const [progress, setProgress] = useState<number | null>(0);

  return (
    <>
      <Header title={headerTitle} />
      {/* {progress !== null && <WebViewProgress progress={progress} />} */}
      <WebView
        javaScriptEnabled
        source={{ uri: link }}
        onLoadProgress={(e) =>
          setProgress(
            e.nativeEvent.progress === 1 ? null : e.nativeEvent.progress
          )
        }
      />
    </>
  );
}
